<!-- Generated template for the OwnerNameComponent component -->
<div>
  {{funzState.owner.name}}
</div>
